/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useEffect, useState } from 'react';
import { useApi } from '../../hooks/useApi';
import styles from './pushNotifications.module.css';
import { useStores } from '../../hooks/useStore';
import { observer } from 'mobx-react';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { Button } from '../../components/UI/Button/Button';
import { ReactComponent as CrossIco } from './icon/delete.svg';
import { ReactComponent as EditIco } from './icon/edit.svg';
import { UserMeResponse } from '../../api/user/dto/UserMeResponse.dto';
import UserPopUP from '../../components/popUp/User/User';
import { PushNotifications } from '../../models/pushNotifications';
import PushNotificationsPopUP from '../../components/popUp/PushNotifications/PushNotifications';

function formatDate(dateStr: string): string {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${day}.${month}.${year} ${hours}:${minutes}`;
}

const PushNotificationsPage: React.FC = observer(() => {
  const api = useApi();
  const store = useStores();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [showForm, setShowForm] = useState<boolean>(false);

  const [sendings, setSendings] = useState<PushNotifications[]>([]);

  useEffect(() => {
    loadSendings();
  }, [page, rowsPerPage]);

  const loadSendings = async () => {
    try {
      store.notificationsStore.showPreloader();
      const { body } = await api.pushNotifications.getAll(
        page * rowsPerPage,
        rowsPerPage,
      );

      if (body) {
        setSendings(body);
      }
    } catch (e) {
      store.notificationsStore.setError('Ошибка при загрузке данных');
    } finally {
      store.notificationsStore.hidePreloader();
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const closeForm = () => {
    setShowForm(false);
  };

  const update = () => {
    loadSendings();
  };

  return (
    <>
      {showForm && (
        <PushNotificationsPopUP onClose={closeForm} update={update} />
      )}
      <div className={styles.container}>
        <div className={styles.pageName}>
          <div className={styles.top}>
            <div className={styles.title}>
              <h2>PUSH рассылки</h2>
            </div>
            <Button
              style={{ maxWidth: 150 }}
              appearance="auth"
              onClick={() => setShowForm(showForm ? false : true)}
            >
              Добавить
            </Button>
          </div>
        </div>

        <div style={{ width: '100%', maxWidth: 1200, margin: '5px' }}>
          <Paper
            sx={{
              width: '100%',
              maxWidth: 1200,
              margin: '5px',
              overflowX: 'auto',
            }}
          >
            <TableContainer style={{ marginTop: 20, overflowX: 'auto' }}>
              <Table sx={{ minWidth: 320 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Заголовок</TableCell>
                    <TableCell align="right">Текст</TableCell>
                    <TableCell align="right">URL</TableCell>
                    <TableCell align="right">Кол-во</TableCell>
                    <TableCell align="right">Успешно</TableCell>
                    <TableCell align="right">Неудачно</TableCell>
                    <TableCell align="right">Дата создания</TableCell>
                    <TableCell align="right">Кто отправил</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sendings &&
                    sendings.map((row) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 },
                          }}
                        >
                          <>
                            <TableCell component="th" scope="row">
                              {row.title}
                            </TableCell>
                            <TableCell align="right">{row.body}</TableCell>
                            <TableCell align="right">{row.url}</TableCell>
                            <TableCell align="right">
                              {row.total_targets}
                            </TableCell>
                            <TableCell align="right">
                              {row.success_count}
                            </TableCell>
                            <TableCell align="right">
                              {row.failure_count}
                            </TableCell>
                            <TableCell align="right">
                              {formatDate(row.created_at)}
                            </TableCell>
                            <TableCell align="right">{row.user.name}</TableCell>
                            <TableCell align="right">
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  justifyContent: 'flex-end',
                                  alignItems: 'center',
                                }}
                              ></div>
                            </TableCell>
                          </>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            </TableContainer>
            <div
              style={{ width: '100%', height: 1, backgroundColor: '#E0E0E0' }}
            />
            <TablePagination
              labelRowsPerPage="Строк на странице"
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={sendings ? sendings.length : 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>
      </div>
    </>
  );
});

export default PushNotificationsPage;
